import moment from 'moment-timezone';
import { environment } from 'environments';

(() => {
  class MailorderController {
    constructor(
      $rootScope,
      $interval,
      $scope,
      $timeout,
      $log,
      $window,
      $state,
      toastr,
      Auth,
      ngDialog,
      Orders,
      Pharmacy,
      Notifications,
      Utils,
      Dosespot,
      Constants,
      MedicationService,
      localStorageService,
      Tracking,
      Users,
      $sce,
    ) {
      'ngInject';

      Object.assign(this, {
        $rootScope,
        $scope,
        $timeout,
        $log,
        $window,
        $state,
        $interval,
        toastr,
        ngDialog,
        Orders,
        Pharmacy,
        Notifications,
        Utils,
        Dosespot,
        Constants,
        MedicationService,
        localStorageService,
        Tracking,
        Users,
        $sce,
        currentUser: Auth.profile,
        polls: {},
        showToggles: false,
        // timezone: $rootScope.timezones[0].timezone,.ENV)
        BOD_634: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
      });

      // $scope.$on('tab:selected:mailorder', this.init.bind(this));

      $scope.$on('tab:selected:mailorder', (event, refreshOrder = false) => {
        // This is to "hide" the animation on toggles during first 500 miliseconds
        // To avoid making confusion to the staff about the auto refill status
        this.showToggles = false;

        this.getMailOrder(refreshOrder);
        this.getDiscountToRecalculatePrice();

        this.$timeout(() => {
          this.showToggles = true;
        }, 500);
      });

      $scope.$on('mailorder:processPayment', () => {
        this.pendingPaymentModal = true;
        this.checkAndTriggerPayment();
      });
    }

    checkAndTriggerPayment(retryCount = 0) {
      this.$timeout(() => {
        const button = document.querySelector('.confirm-refill-payment-button:not([disabled])');
        if (button) {
          button.click();
          this.pendingPaymentModal = false;
        } else if (retryCount < 3) {
          this.checkAndTriggerPayment(retryCount + 1);
        } else {
          this.pendingPaymentModal = false;
        }
      }, 600);
    }

    $onInit() {
      this.timezone = this.parent.timezone;
      this.pimsParameters = this.localStorageService.get('pimsParameters');
    }

    init() {
      // This is to "hide" the animation on toggles during first 500 miliseconds
      // To avoid making confusion to the staff about the auto refill status
      this.showToggles = false;

      this.getMailOrder(false);

      this.$timeout(() => {
        this.showToggles = true;
      }, 500);

      this2.mailOrderCancelOptions = [];

      if (data.pharmacy_options && data.pharmacy_options.length) {
        data.pharmacy_options.forEach(pharmacy_option => {
          pharmacy_option.id = pharmacy_option.id.toString();
          this2.pharmacyOptions.push(pharmacy_option);
        });
      }
    }

    formatDate(iso_date, timezone) {
      if (!iso_date) return null;
      let formatted_date = moment.tz(iso_date, timezone).format('DD/MMM/YY');
      return formatted_date;
    }

    showFullAddress(RefillDetails) {
      RefillDetails.showFullAddress = !RefillDetails.showFullAddress;
    }

    reopenMailOrder(mail_order_id, data) {
      this.confirmReopenMailOrder(mail_order_id, data);

      // var this2 = this;
      // var mailorderstatus = {"status" : data };

      // this2.Orders.cancelMailorder(mail_order_id , mailorderstatus)
      //   .then(({ data }) => {

      //     //this2.visit = this2.Orders.current;
      //     this2.toastr.success('MailOrder was ' + data);

      //   })
      //   .catch((err) => {
      //     if (err.status === 409) {
      //       this2.toastr.error('Error getting order details: ' + err.data.message.summary);
      //     } else {
      //       this2.toastr.error('Error getting order details: ' + err.status + ' - ' + err.message);
      //     }
      //   });
    }

    confirmReopenMailOrder(mail_order_id, data) {
      this.data2 = data;
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: data + ' MailOrder',
          content: 'Are you sure you want to ' + data + ' mailorder',
        },
      };

      this.ngDialog.openConfirm(config).then(() => {
        var this2 = this;
        var mailorderstatus = {
          status: data,
        };
        mailorderstatus.cancel_reason_code = null;
        // mailorderstatus.auto_refill = true;

        this2.Orders.cancelMailorder(mail_order_id, mailorderstatus)
          .then(({ data }) => {
            //this2.visit = this2.Orders.current;
            this2.toastr.success('MailOrder was ' + this.data2);
            this2.getMailOrder(true);
          })
          .catch(err => {
            if (err.status === 409) {
              this2.toastr.error('Error getting order details: ' + err.data.message.summary);
            } else {
              this2.toastr.error('Error getting order details: ' + err.status + ' - ' + err.message);
            }
          });
      });
    }

    getDiscountToRecalculatePrice() {
      this.Orders.getRecalculatedPrice(this.visit.id)
        .then(({ data }) => {
          this.membershipDiscount = data.fee.membership.discount.value;
        })
        .catch(err => {
          console.error('Error getting discount recalculate price:', err);
          this.membershipDiscount = null;
        });
    }

    openCancelMailOrderModal(mail_order_id, callback) {
      return this.ngDialog.open({
        templateUrl: 'app/components/confirm-mailorder-cancellation/confirm-mailorder-cancellation.html',

        // To not allow the user closes the modal without explicitely to have some action

        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        controller: 'ConfirmMailOrderCancellationController',
        controllerAs: 'vm',
        data: {
          mail_order_id,
        },
        preCloseCallback(response) {
          return callback(response);
        },
      });
    }

    cancelMailOrder(mail_order_id) {
      this.openCancelMailOrderModal(mail_order_id, response => {
        if (response && response != '$closeButton') {
          response['auto_refill'] = false;
          this.Orders.cancelMailorder(mail_order_id, response)
            .then(({ data }) => {
              //this2.visit = this2.Orders.current;
              this.toastr.success('MailOrder was successfully cancelled');
              this.getMailOrder(true);
            })
            .catch(err => {
              if (err.status === 409) {
                this.toastr.error('Error getting order details: ' + err.data.message.summary);
              } else {
                this.toastr.error('Error getting order details: ' + err.status + ' - ' + err.message);
              }
            });
        }
      });
    }

    editPharmacyDetails(prescription) {
      prescription.mail_order.editingRefillDetails = true;
    }

    togglePharmacyClick(event, prescription) {
      if (prescription.collect_in_store) {
        prescription.collect_in_store = false;
        this.changeHomeDeliveryModal(prescription);
      } else {
        this.openPharmacyDialog(this.patient.address, prescription);
        prescription.collect_in_store = true;
      }

      event.preventDefault();
      event.stopPropagation();
    }

    changeHomeDeliveryModal(prescription) {
      let title = 'Change to home delivery?';
      let content = 'Confirm that the patient would like future refills sent to their home address';
      const dialogConfig = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: title,
          content: content,
          buttons: {
            confirm: 'Yes, confirm',
            cancel: 'Close',
          },
        },
      }; // For all popups mongo tracking
      // We should use 'showPopup' as action label

      var trackingDetails = {
        title: title,
        content: content,
      };
      this.Tracking.trackEvent('showPopup', ['Auto Refills', 'Change to home delivery popup', trackingDetails]);
      this.ngDialog
        .openConfirm(dialogConfig)
        .then(
          success => {
            // CONFIRM BUTTON PRESSED
            // Passing in Boots Pharmacy ID 2167
            this.Pharmacy.fetch(4900).then(({ data }) => {
              this.previousPharmacy = prescription.pharmacy;
              prescription.pharmacy = data;
            });
            // this.Orders.updateMailOrderPrescriptionPharmacy(prescription.mail_order.id, prescription.id, 2167)

            this.Tracking.trackAction('click', [
              'Auto Refills',
              'Change to home delivery popup',
              'Yes',
              trackingDetails,
            ]);
          },
          error => {
            // CANCEL BUTTON PRESSED
            prescription.collect_in_store = true;

            this.Tracking.trackAction('click', ['Change to home delivery popup', 'Go Back', trackingDetails]);
          },
        )
        .catch(err => {
          // APPLICATION ERROR
          console.log(err);

          // TRACKING error on Mongo DB
          var newErr = {};
          newErr.errApi = err;
          newErr.trackingDetails = trackingDetails;

          this.Tracking.trackError(newErr, 'ngDialog.openConfirm : Change to home delivery popup');
        });
    }

    toggleClick(event, mail_order) {
      let show_cancel_reasons_popup =
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.show_cancel_reasons_popup &&
        this.pimsParameters.pimsVisitParameters.show_cancel_reasons_popup.includes(this.visit.service.code);

      if (mail_order.auto_refill && show_cancel_reasons_popup) {
        this.cancelAutoDelivery(mail_order);
        mail_order.auto_refill = !mail_order.auto_refill;
      } else {
        mail_order.auto_refill = !mail_order.auto_refill;
      }

      event.stopPropagation();
      event.preventDefault();
    }

    openCancelAutoDeliveryModal(mail_order_id, callback) {
      return this.ngDialog.open({
        templateUrl: 'app/components/confirm-autodelivery-cancellation/confirm-autodelivery-cancellation.html',

        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        controller: 'ConfirmAutoDeliveryCancellationController',
        controllerAs: 'vm',
        data: {
          mail_order_id,
        },
        preCloseCallback(response) {
          return callback(response);
        },
      });
    }

    openPharmacyDialog(address, prescription) {
      this.Pharmacy.openSearchDialog(address, true).then(pharmacy => {
        if (!pharmacy) {
          prescription.collect_in_store = false;
          return;
        }
        this.previousPharmacy = prescription.pharmacy;
        prescription.pharmacy = pharmacy;
      });
    }

    cancelAutoDelivery(mail_order) {
      this.openCancelAutoDeliveryModal(mail_order.id, response => {
        if (response && response != '$closeButton') {
          this.Orders.cancelMailorder(mail_order.id, response)
            .then(({ data }) => {
              this.toastr.success('Auto delivery was succesfully cancelled');
              this.getMailOrder(true);
            })
            .catch(err => {
              if (err.status === 409) {
                this.toastr.error('Error getting order details: ' + err.data.message.summary);
              } else {
                this.toastr.error('Error getting order details ' + err.status + ' - ' + err.message);
              }
            });
        }
      });
    }

    getMailOrder(refreshOrder) {
      this.today = moment().format('YYYY-MM-DD');
      this.visitHasFillSentToday = false;

      if (refreshOrder) {
        this.Orders.getOne(this.Orders.current.id)
          .then(({ data }) => {
            Object.assign(this.Orders.current, data);
            this.visit = this.Orders.current;
            this.setupData();
          })
          .catch(err => {
            if (err.status === 409) {
              this.toastr.error('Error getting order details: ' + err.data.message.summary);
            } else {
              this.toastr.error('Error getting order details: ' + err.status + ' - ' + err.message);
            }
          });
      } else {
        // HERE WE AVOID SECOND API CALL TO GET ADMIN/ORDER
        // AFTER DOCTOR JUST OPENED A NEW VISIT
        this.visit = this.Orders.current;
        this.setupData();
      }
    }

    setupData() {
      var prescriptionArray = this.visit.prescriptions;
      prescriptionArray = prescriptionArray.filter(v => v.mail_order);

      prescriptionArray.sort(function (a, b) {
        return b.id - a.id;
      });

      prescriptionArray.forEach(prescription => {
        if (prescription.pharmacy.mailorder_partner) {
          prescription.collect_in_store = false;
        } else {
          prescription.collect_in_store = true;
        }

        // prescription.amountCharged = prescription.dispense_amount * prescription.unit_price;

        prescription.mail_order.editingRefillDetails = false;
        prescription.processing = false;
        prescription.mail_order.refillOptions = ['One time', 'Recurring'];

        if (prescription.mail_order.next_refill_date) {
          prescription.mail_order.next_refill_date_asDate = moment(
            prescription.mail_order.next_refill_date,
            'YYYY-MM-DD',
          ).toDate();
        } else {
          prescription.mail_order.next_refill_date_asDate = null;
        }

        prescription.mail_order_original = angular.copy(prescription.mail_order);
        prescription.mail_order.anyReprocessPending = false;

        // AS WE DISCUSSED WITH MERYL
        // WE ARE NOT SHOWING THE REFILL DATE ON THE HEADER SECTION (JUST ON THE FILLS SECTION)
        //
        // if (prescription.mail_order.fill_requests && prescription.mail_order.fill_requests.length) {
        //   prescription.mail_order.fill_date = prescription.mail_order.fill_requests[0].fill_date;
        // }

        prescription.mail_order.fill_requests.forEach(fillRequest => {
          // FOR EACH FILL REQUEST

          // fillRequest.amountCharged = prescription.amountCharged * fillRequest.num_to_charge;

          fillRequest.discount_active = false;

          var medication_amount_after_discount = fillRequest.medication_amount_after_discount
            ? fillRequest.medication_amount_after_discount
            : 0;
          var medication_amount_before_discount = fillRequest.medication_amount_before_discount
            ? fillRequest.medication_amount_before_discount
            : 0;

          if (medication_amount_after_discount < medication_amount_before_discount) {
            fillRequest.discount_active = true;
            fillRequest.amountCharged =
              fillRequest.medication_amount_before_discount * fillRequest.num_to_charge -
              (fillRequest.medication_amount_before_discount - fillRequest.medication_amount_after_discount);
          } else {
            fillRequest.amountCharged =
              prescription.dispense_amount * prescription.unit_price * fillRequest.num_to_charge;
          }

          fillRequest.updateFill = false;
          fillRequest.reprocessing = false;
          fillRequest.reprocessPayment = false;
          fillRequest.reprocessFillRequest = false;
          fillRequest.button_label = null;
          fillRequest.deleteRequest = false;
          fillRequest.cancelRequest = false;
          fillRequest.showFullAddress = false;

          if (fillRequest.sent) {
            if (this.today === moment(fillRequest.sent).format('YYYY-MM-DD')) {
              this.visitHasFillSentToday = true;
            }
          }

          if (fillRequest.payment_status) fillRequest.payment_status = fillRequest.payment_status.toUpperCase();
          if (fillRequest.status) fillRequest.status = fillRequest.status.toUpperCase();

          if (fillRequest.status === 'ERROR' && fillRequest.payment_status === 'SETTLED') {
            fillRequest.reprocessFillRequest = true;
            prescription.mail_order.anyReprocessPending = true;
          }

          if (fillRequest.status === 'OPEN' || fillRequest.status === 'PENDING') {
            fillRequest.deleteRequest = true;
          } else if (fillRequest.status === 'CANCELLED') {
            fillRequest.cancelRequest = false;
          } else {
            fillRequest.cancelRequest = true;
          }

          if (fillRequest.status != 'CANCELLED') {
            if (fillRequest.payment_status === 'FAILED' || fillRequest.payment_status === 'OPEN') {
              fillRequest.reprocessPayment = true;
              prescription.mail_order.anyReprocessPending = true;
            } else if (!fillRequest.sent) {
              fillRequest.reprocessFillRequest = true;
              prescription.mail_order.anyReprocessPending = true;
            }
          }

          if (fillRequest.reprocessPayment || fillRequest.reprocessFillRequest) {
            fillRequest.button_label = 'Reprocess';
          }
        });
      });

      this.prescriptionArray = prescriptionArray;
    }

    callRejectModal(callback) {
      return this.ngDialog.open({
        templateUrl: 'app/components/reject-mailorder-refill/reject-mailorder-refill.html',

        // To not allow the user closes the modal without explicitely to have some action

        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        controller: 'RejectMailOrderRefillController',
        controllerAs: 'reject',
        preCloseCallback(res) {
          if (res === true) {
            return callback(true);
          }
          return callback(false);
        },
      });
    }

    addFillRequest(prescription) {
      var this2 = this;

      this.Orders.getRefillsData(prescription.mail_order.order_line_medication_id)
        .then(({ data }) => {
          prescription.refillsData = data;
          prescription.showAddRefillsForm = true;
        })
        .catch(err => {
          if (err.status === 409) {
            this2.toastr.error('Error: ' + err.data.message.summary);
          } else {
            this2.toastr.error('Error getting the Fill Request: ' + err.status + ' - ' + err.message);
          }
        });
    }

    sendFillRequest(prescription) {
      var this2 = this;

      this2.updating = true;

      this.Orders.sendRefills(prescription.refillsData)
        .then(({ data }) => {
          prescription.showAddRefillsForm = false;
          this2.toastr.success('Fill Request was sent.');
          this2.getMailOrder(true);
        })
        .catch(err => {
          if (err.status === 409) {
            this2.toastr.error('Error: ' + err.data.message.summary);
          } else {
            this2.toastr.error('Error sending Fill Request: ' + err.status + ' - ' + err.message);
          }
        })
        .finally(() => {
          this2.updating = false;
        });
    }

    cancelAddFillRequest(prescription) {
      prescription.showAddRefillsForm = false;
    }

    cancelEditFillRequest(RefillDetails) {
      RefillDetails.updateFill = false;
    }

    updateFillRequest(RefillDetails) {
      var this2 = this;

      this.Orders.updateRefills(RefillDetails.id, RefillDetails.refillsData)
        .then(({ data }) => {
          RefillDetails.updateFill = false;
          this2.toastr.success('Fill Request was updated.');
          this2.getMailOrder(true);
        })
        .catch(err => {
          if (err.status === 409) {
            this2.toastr.error('Error: ' + err.data.message.summary);
          } else {
            this2.toastr.error('Error updating Fill Request: ' + err.status + ' - ' + err.message);
          }
        });
    }

    cancelRefillChanges(prescription) {
      prescription.mail_order.days_between_refills = angular.copy(
        prescription.mail_order_original.days_between_refills,
      );
      prescription.mail_order.refills_remaining = angular.copy(prescription.mail_order_original.refills_remaining);
      // prescription.mail_order.next_refill_date = angular.copy(prescription.mail_order_original.next_refill_date);
      // prescription.mail_order.next_refill_date_asDate = angular.copy(prescription.mail_order_original.next_refill_date_asDate);
      prescription.mail_order.auto_refill = angular.copy(prescription.mail_order_original.auto_refill);
      prescription.mail_order.editingRefillDetails = false;

      if (this.previousPharmacy) {
        prescription.pharmacy = this.previousPharmacy;
        if (this.previousPharmacy.mailorder_partner) {
          prescription.collect_in_store = false;
        } else {
          prescription.collect_in_store = true;
        }
        // this.previousPharmacy = {};
      } else {
        return;
      }
    }

    saveRefillChanges(prescription) {
      var this2 = this;

      if (!prescription.mail_order.refills_remaining) {
        this2.toastr.error('Please enter how many refills remaining');
        return;
      }

      if (!prescription.mail_order.days_between_refills) {
        this2.toastr.error('Please enter how many days between refills');
        return;
      }

      // WE REMOVED THE FILL DATE FROM THE HEADER SECTION
      //
      // if (!prescription.mail_order.next_refill_date_asDate || prescription.mail_order.next_refill_date_asDate === 'Invalid date') {
      //   prescription.mail_order.next_refill_date = null;
      // } else {
      //   prescription.mail_order.next_refill_date = moment(prescription.mail_order.next_refill_date_asDate).format('YYYY-MM-DD');
      // }

      // if (prescription.mail_order.auto_refill) {
      //   if (!prescription.mail_order.next_refill_date) {
      //     this2.toastr.error('Please enter the next scheduled refill date');
      //     return;
      //   }

      //   var today = moment().format('YYYY-MM-DD');

      //   if (today > prescription.mail_order.next_refill_date) {
      //     this2.toastr.error("The next scheduled refill date can't be in the past");
      //     return;
      //   }
      // }

      this.refillInfoObject = {
        auto_refill: prescription.mail_order.auto_refill,
        // "next_refill_date": prescription.mail_order.next_refill_date,
        refills_remaining: parseInt(prescription.mail_order.refills_remaining),
        days_between_refills: parseInt(prescription.mail_order.days_between_refills),
      };

      if (isNaN(this.refillInfoObject.refills_remaining) || this.refillInfoObject.refills_remaining === 0) {
        this2.toastr.error('Error updating mailorder details: Please input a number of refills greater than zero');
        return;
      }

      this.Orders.updateRefillInfo(prescription.mail_order.id, this.refillInfoObject)
        .then(({ data }) => {
          prescription.mail_order.editingRefillDetails = false;
          const orderId = FEATURE_BODACDC_5212 ? this.visit.id : prescription.mail_order.id;
          this.Orders.updateMailOrderPrescriptionPharmacy(
            orderId,
            prescription.id,
            prescription.pharmacy.id,
          )
            .then(({ data1 }) => {
              this2.toastr.success('Mailorder details updated');
              this.getMailOrder(true);
            })
            .catch(err => {
              if (err.status === 409) {
                this2.toastr.error('Error updating mailorder details: ' + err.data.message.summary);
              } else {
                this2.toastr.error('Error updating mailorder details: ' + err.status + ' - ' + err.message);
              }
            });
        })
        .catch(err => {
          if (err.status === 409) {
            this2.toastr.error('Error updating mailorder details: ' + err.data.message.summary);
          } else {
            this2.toastr.error('Error updating mailorder details: ' + err.status + ' - ' + err.message);
          }
        });
    }

    processPaymentFillRequest(prescription) {
      if (this.visitHasFillSentToday) {
        this.callFillSentTodayWarningModal()
          .then(success => {
            // CONTINUE BUTTON PRESSED
            this.callProcessModal(
              prescription,
              result => {
                this.getMailOrder(true);
              },
              err => {
                this2.getMailOrder(true);
              },
            );
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.callProcessModal(
          prescription,
          result => {
            this.getMailOrder(true);
          },
          err => {
            this2.getMailOrder(true);
          },
        );
      }
    }

    callProcessModal(prescription, callback) {
      const { visit } = this;

      const modalData = {
        visit,
        prescription,
      };
      modalData.membershipDiscount = this.membershipDiscount;

      return this.ngDialog.open({
        templateUrl: 'app/components/charge-mailorder-refill/charge-mailorder-refill.html',

        // To not allow the user closes the modal without explicitely to have some action

        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        controller: 'ChargeMailOrderRefillController',
        controllerAs: 'mailorder',
        data: modalData,
        preCloseCallback(res) {
          if (res === true) {
            return callback(true);
          }
          return callback(false);
        },
      });
    }

    reprocessPaymentFillRequest(mail_order_id, RefillDetails, prescription) {
      var this2 = this;

      if (this.visitHasFillSentToday) {
        this.callFillSentTodayWarningModal()
          .then(
            success => {
              // CONTINUE BUTTON PRESSED
              this2.callReprocessModal(
                mail_order_id,
                RefillDetails,
                prescription,
                result => {
                  this2.getMailOrder(true);
                },
                err => {
                  this2.getMailOrder(true);
                },
              );
            },
            error => {
              // GO BACK BUTTON PRESSED
              // OR CLOSE BUTTON PRESSED
            },
          )
          .catch(err => {
            // APPLICATION ERROR
            console.log(err);
          });
      } else {
        this2.callReprocessModal(
          mail_order_id,
          RefillDetails,
          prescription,
          result => {
            this2.getMailOrder(true);
          },
          err => {
            this2.getMailOrder(true);
          },
        );
      }
    }

    reprocessFailedFillRequest(mail_order_id, RefillDetails, prescription) {
      var this2 = this;

      this.callReprocessFillModal(
        mail_order_id,
        RefillDetails,
        prescription,
        result => {
          this2.getMailOrder(true);
        },
        err => {
          this2.getMailOrder(true);
        },
      );
    }

    deleteFill(mail_order_id, fill_id, cancelDeleteFlag) {
      const dialogConfig = {
        template: 'app/components/modals/confirm.tpl.html',

        // To not allow to the user to close the modal without explicitely to have some action
        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        data: {
          title: 'Are you sure?',
          content: 'Do you want to ' + cancelDeleteFlag + ' Fill Request',
          buttons: {
            hideCancel: false,
            confirm: 'Yes',
            cancel: 'No',
          },
        },
      };

      this.ngDialog
        .openConfirm(dialogConfig)
        .then(
          success => {
            // OK BUTTON PRESSED
            this.confirmDeleteFill(mail_order_id, fill_id, cancelDeleteFlag);
          },
          error => {
            // CANCEL BUTTON PRESSED
            // OR CLOSE BUTTON PRESSED
            console.log('Cancel');
          },
        )
        .catch(err => {
          // APPLICATION ERROR
          console.log(err);
        });
    }

    confirmDeleteFill(mail_order_id, fill_id, cancelDeleteFlag) {
      this.Orders.deleteFillRequest(mail_order_id, fill_id)
        .then(() => {
          if (cancelDeleteFlag === 'delete') {
            this.toastr.success('Mailorder refill deleted');
          } else {
            this.toastr.success('Mailorder refill canceled');
          }
          this.getMailOrder(true);
        })
        .catch(err => {
          this.toastr.error('Error: ' + err.data.message.summary);
          this.getMailOrder(true);
        });
    }

    callReprocessModal(mail_order_id, RefillDetails, prescription, callback) {
      const { visit } = this;

      return this.ngDialog.open({
        templateUrl: 'app/components/reprocess-charge-refill/reprocess-charge-refill.html',

        // To not allow the user closes the modal without explicitely to have some action

        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        controller: 'ReprocessChargeRefillController',
        controllerAs: 'mailorder',
        data: {
          visit,
          prescription,
          mail_order_id,
          RefillDetails,
        },
        preCloseCallback(res) {
          if (res === true) {
            return callback(true);
          }
          return callback(false);
        },
      });
    }

    callFillSentTodayWarningModal() {
      const dialogConfig = {
        template: 'app/components/modals/confirm.tpl.html',

        // To not allow the user closes the modal without explicitely to have some action

        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        data: {
          title: 'Mail Order Refill Warning',
          content: 'A mail order refill was processed today for this visit',
          buttons: {
            hideCancel: false,
            confirm: 'Continue',
            cancel: 'Go back',
          },
        },
      };

      return this.ngDialog.openConfirm(dialogConfig);
    }

    isDispenseOrderPendingStatus(status) {
      return !this.isDispenseOrderCancelledStatus(status) && !this.isDispenseOrderSuccessStatus(status);
    }

    isDispenseOrderCancelledStatus(status) {
      return [
        'Cancelled out of stock',
        'Cancelled by patient',
        'Cancelled clinical decision by pharmacist',
        'Cancelled uncollected',
        'Cancelled returned package',
        'Cancelled by Columbus',
      ].includes(status);
    }

    isDispenseOrderSuccessStatus(status) {
      const successStatuses = ['Printed', 'Completed', 'Collected'];
      return successStatuses.includes(status);
    }

    getStatusColor(status, o2dReceived) {
      if (['Printed', 'Completed'].includes(status)) return 'color-warning'; // orange
      if (this.isDispenseOrderCancelledStatus(status)) return 'color-alert'; // red
      if (['Collected'].includes(status)) return 'color-success'; // green
      if (o2dReceived) {
        return 'color-submitted'; // purple
      } else {
        return 'color-gray-md';
      }
    }

    getDispensingStatusLabel(dispensing_status, o2dReceived) {
      return (dispensing_status?.toLowerCase() === 'new' && !!o2dReceived) ? 'Sent to Columbus' : dispensing_status;
    }

    callReprocessFillModal(mail_order_id, RefillDetails, prescription, callback) {
      const { visit } = this;

      return this.ngDialog.open({
        templateUrl: 'app/components/reprocess-failed-refill/reprocess-failed-refill.html',

        // To not allow the user closes the modal without explicitely to have some action

        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        controller: 'ReprocessFailedRefillController',
        controllerAs: 'mailorder',
        data: {
          visit,
          prescription,
          mail_order_id,
          RefillDetails,
        },
        preCloseCallback(res) {
          if (res === true) {
            return callback(true);
          }
          return callback(false);
        },
      });
    }

    // reprocessFillRequest(mail_order_id, RefillDetails) {

    //   var this2 = this;

    //   RefillDetails.reprocessing = true;
    //   this.Orders.reprocessFillRequest(mail_order_id, RefillDetails.id, false, true)
    //   .then(({ data }) => {
    //     this2.toastr.success("Fill Request was reprocessed successfully.");
    //     this2.getMailOrder(true);
    //   })
    //   .catch((err) => {
    //     if (err.status === 409) {
    //       this2.toastr.error('Error reprocessing refill request: ' + err.data.message.summary);
    //     } else {
    //       this2.toastr.error('Error: ' + err.status + ' - ' + err.message);
    //     }
    //     this2.getMailOrder(true);
    //   })
    //   .finally(() => {
    //     RefillDetails.reprocessing = false;
    //   });
    // }

    // reprocessPaymentFillRequest_OLD_VERSION(mail_order_id, RefillDetails) {

    //   var reprocessPayment = RefillDetails.reprocessPayment;
    //   var reprocessFillRequest = RefillDetails.reprocessFillRequest;
    //   var this2 = this;

    //   if (reprocessPayment) {

    //     RefillDetails.reprocessing = true;
    //     this.Orders.reprocessFillRequest(mail_order_id, RefillDetails.id, true, false)
    //     .then(({ data }) => {
    //       this2.toastr.success("Payment was reprocessed successfully.");

    //       if (reprocessFillRequest) {
    //         this2.reprocessFillRequest(mail_order_id, RefillDetails);
    //       } else {
    //         this2.getMailOrder(true);
    //       }
    //     })
    //     .catch((err) => {
    //       if (err.status === 409) {
    //         if (reprocessFillRequest) {

    //           // Calling reject popup to still send the fill request
    //           this2.callRejectModal((result) => {
    //             if (result) {
    //               this2.reprocessFillRequest(mail_order_id, RefillDetails);
    //             } else {
    //               // If user just closes the popup
    //               this2.getMailOrder(true);
    //             }
    //           });
    //         } else {
    //           this2.toastr.error('Error reprocessing payment: ' + err.data.message.summary);
    //           this2.getMailOrder(true);
    //         }
    //       } else {
    //         this2.toastr.error('Error: ' + err.status + ' - ' + err.message);
    //         this2.getMailOrder(true);
    //       }
    //     })
    //     .finally(() => {
    //       RefillDetails.reprocessing = false;
    //     });

    //   } else if (reprocessFillRequest) {

    //     this2.reprocessFillRequest(mail_order_id, RefillDetails);

    //   }
    // }

    // transferPharmacyRequest(){

    //   this.medication_array = [];
    //   this.med = this.visit.order_lines[0].medications;

    //   if (!this.med || this.med.length === 0) {
    //     this.toastr.error('There are no medications prescribed.');
    //     return;
    //   }

    //   for(var i = 0; i < this.med.length; i++){
    //     this.medication_array.push(this.med[i].name);
    //   }

    //   this.Users.getStaffUser(this.med[0].prescribed_by)
    //   .then(({ data }) => {

    //     var prescriber = data.title + ' ' + data.firstname + ' ' + data.lastname;

    //     this.transferPharmacyObject = {
    //       "order_id" : this.visit.id,
    //       "patient_first_name": this.visit.user.firstname,
    //       "patient_last_name":  this.visit.user.lastname,
    //       "patient_gender": this.visit.user.gender,
    //       "patient_dob": this.visit.user.dob.substring(0, 10),
    //       "current_pharmacy_name": this.visit.pharmacy.name,
    //       "current_pharmacy_phone": this.visit.pharmacy.phone,
    //       "prescriber_name": prescriber,
    //       "prescriber_phone": this.visit.currentUser.phones[0].number,
    //       "medication_name": this.medication_array
    //     };

    //     this.showTransferPharmcyForm = true;
    //   })
    //   .catch((err) => {

    //   });
    // }

    // cancelTransferPharmacyRequest() {

    //   this.showTransferPharmcyForm = false;
    // }

    // sendTransferPharmacy(transferrequests) {

    //   this.transferrequests = transferrequests;
    //   this.transferrequests.patient_dob = this.transferrequests.patient_dob.replace(/-/gi, "");

    //   var this2 = this;

    //   this.Orders
    //   .sendTransferRequests(this.transferrequests)
    //   .then(({ data }) => {
    //     this2.showTransferPharmcyForm = false;
    //     this2.toastr.success('Transfer Pharmacy Request was sent.');

    //   })
    //   .catch((err) => {
    //     if (err.status === 409) {
    //       this2.toastr.error('Error: ' + err.data.message.summary);
    //     } else {
    //       this2.toastr.error('Error sending the Transfer Pharmacy Request: ' + err.status + ' - ' + err.message);
    //     }
    //   });
    // }
  }

  MailorderController.$inject = [
    '$rootScope',
    '$interval',
    '$scope',
    '$timeout',
    '$log',
    '$window',
    '$state',
    'toastr',
    'Auth',
    'ngDialog',
    'Orders',
    'Pharmacy',
    'Notifications',
    'Utils',
    'Dosespot',
    'Constants',
    'MedicationService',
    'localStorageService',
    'Tracking',
    'Users',
    '$sce',
  ];
  angular.module('pims').component('visitMailorder', {
    templateUrl: 'app/views/visits/detail/sections/mailorderRefills/mailorderRefills.html',
    controller: MailorderController,
    bindings: {
      visit: '=',
      parent: '=',
      patient: '=',
    },
  });
})();
